import axiosInstance from "./AxiosInstance";

// Histórico persistente de notificações
export function listUserNotifications(opts = {}) {
  const params = {};
  if (opts.unreadOnly) params.unread_only = 1;
  if (opts.limit) params.limit = opts.limit;
  if (opts.alertType) params.alert_type = opts.alertType;
  if (opts.since) params.since = opts.since;
  return axiosInstance.get(`/user/notifications/recent`, { params });
}

export function markNotificationRead(notificationId) {
  return axiosInstance.post(`/user/notifications/${notificationId}/read`, {});
}

export function markAllNotificationsRead(alertType = null) {
  return axiosInstance.post(
    `/user/notifications/read-all`,
    alertType ? { alert_type: alertType } : {},
  );
}

export function deleteNotification(notificationId) {
  return axiosInstance.delete(`/user/notifications/${notificationId}`);
}

export function deleteUserNotifications(payload = {}) {
  return axiosInstance.post(`/user/notifications/delete`, payload);
}

// Preferências (já existia em invoicingServices, replicado aqui para coesão)
export function getAlertPreferences() {
  return axiosInstance.get(`/user/alert-preferences`);
}

export function setAlertPreferences(payload) {
  return axiosInstance.post(`/user/alert-preferences`, payload);
}

export function sendTestAlert(alertType = "sales") {
  return axiosInstance.post(`/user/alert-preferences/test`, {
    alert_type: alertType,
  });
}
